import {defineMessages} from 'react-intl';

const messages = defineMessages({
    TICKET_NUMBER: {
        id: 'techDoc.export.form.ticketNumber',
        defaultMessage: 'Ticket No.'
    },
    DATE_FROM: {
        id: 'techDoc.export.form.dateFrom',
        defaultMessage: 'Date From'
    },
    DATE_TO: {
        id: 'techDoc.export.form.dateTo',
        defaultMessage: 'Date To'
    },
    ASSIGNED: {
        id: 'techDoc.export.form.assigned',
        defaultMessage: 'Assigned to'
    },
    STATUS: {
        id: 'techDoc.export.form.status',
        defaultMessage: 'Status'
    },
    SOLUTION_GROUP: {
        id: 'techDoc.export.form.solutionGroup',
        defaultMessage: 'Solution Group'
    },
    DEALER_NUMBER: {
        id: 'techDoc.export.form.dealerNumber',
        defaultMessage: 'Dealer No.'
    },
    DEALER_NAME: {
        id: 'techDoc.export.form.dealerName',
        defaultMessage: 'Dealer Name'
    },
    TYPE: {
        id: 'techDoc.export.form.type',
        defaultMessage: 'Type'
    },
    XLS: {
        id: 'techDoc.export.form.xls',
        defaultMessage: 'XLS'
    },
    CSV: {
        id: 'techDoc.export.form.csv',
        defaultMessage: 'CSV'
    },
    EXPORT_STATUS: {
        id: 'techDoc.export.exportStatus',
        defaultMessage: 'Export status:'
    },
    LAST_EXPORT: {
        id: 'techDoc.export.lastExport',
        defaultMessage: 'Last export:'
    }
});

export default messages;
